"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCY_CODES = void 0;
exports.CURRENCY_CODES = [
    "EUR",
    "USD",
    "CAD",
    "HKD",
    "ISK",
    "PHP",
    "DDK",
    "HUF",
    "CZK",
    "AUD",
    "RON",
    "SEK",
    "IDR",
    "INR",
    "BRL",
    "RUB",
    "HRK",
    "JPY",
    "TBH",
    "CHF",
    "SGD",
    "PLN",
    "BGN",
    "TRY",
    "CNY",
    "NOK",
    "NZD",
    "ZAR",
    "MXN",
    "ILS",
    "GBP",
    "KRW",
    "MYR",
];
